export function getMenuList(allChats) {
  const conversations = Array.isArray(allChats) ? allChats : [];

  const getTypeLabel = (conversationType = "") => {
    const normalizedType = String(conversationType).toLowerCase();
    if (normalizedType.includes("organization")) {
      return "Organization";
    }
    return "Individual";
  };

  const routes = conversations.map(({ _id, conversationType, title }, index) => ({
    type: getTypeLabel(conversationType),
    menus: [
      {
        href: _id,
        label: title?.trim() || `Chat ${index + 1}`,
        _id,
        submenus: [],
        active: false,
      },
    ],
  }));

  return routes;
}
